module.exports = __webpack_public_path__ + "img/2.073c1204.jpg";